<template>
  <div class="container-fluid">
    <span class="resize-loading" v-if="!client">
      <span class="loader"></span>
    </span>
    <client-form
      v-if="client"
      :loading="loading"
      :clientData="client"
      :formErrors="formErrors"
      @clientSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import ClientForm from "../partials/ClientForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { ClientForm },

  mixins: [alertLeave, requestErrorMixin],

  props: {
    clientId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      client: null,
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("clients/get", this.clientId);
        const client = this.$store.getters["clients/client"];
        this.client = {
          ...client,
        };
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.loading = false;
      }
    },

    async handleSubmit(client) {
      this.loading = true;

      const clientData = cloneDeep(client);

      try {
        await this.$store.dispatch("clients/update", clientData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("CLIENTS.CLIENTS_UPDATED"),
        });
        let client = this.$store.getters["clients/client"];
        client = {
          ...client,
          manager: client?.manager?.id
            ? client?.manager
            : {
                type: "users",
                id: null,
              },
        };
        this.$emit("onViewClient", client, true);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error?.response?.status === 403) {
          await this.showRequestError(error);
        } else {
          this.$notify({
            type: "danger",
            message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
          });
          this.formErrors = error.response.data.errors;
        }
      }
    },
  },
};
</script>
